import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({ selector: '[appNumbersOnly]' })
export class NumbersOnlyDirective {
  private _el = inject(ElementRef);
  private ngControl = inject(NgControl);

  @HostListener('input', ['$event']) onInputChange(event: any) {
    const initialValue = this._el.nativeElement.value;
    const numericValue = initialValue.replace(/[^0-9]*/g, '');

    if (initialValue !== numericValue) {
      this._el.nativeElement.value = numericValue;

      if (this.ngControl.control) {
        this.ngControl.control.setValue(numericValue, { emitEvent: false });
      }

      event.stopPropagation();
    }
  }

  @HostListener('keypress', ['$event']) onKeyPress(event: any) {
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
    const isNumeric = /[0-9]/.test(event.key);
    const isAllowedKey = allowedKeys.includes(event.key);

    if (!isNumeric && !isAllowedKey) {
      event.preventDefault();
    }
  }
}
